<template>
<div>
    <div class="row">
      <div class="col-12">
        <h2>Alerts</h2>
        <hr>
      </div>
    </div>
  <div class="row">
    <div class="col-12">
      <router-link :to="{ name: 'EventAdd', params: { event_type_id: 3 } }" class="btn btn-success"><i class="fa fa-edit" aria-hidden="true"></i>
        Add Alert
      </router-link>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-12">
      <table class="table table-striped">
        <thead class="bg-hub-primary text-white">
        <tr>
          <th style="width: 20%;">Name</th>
          <th style="width: 15%;" class="d-none d-md-table-cell">Device</th>
          <th style="width: 15%;" class="d-none d-md-table-cell">Input</th>
          <th style="width: 15%;">Extension</th>
          <th style="width: 20%;" class="d-none d-md-table-cell pl-4">Step Summary</th>
          <th style="width: 10%;">Manage</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="alert in filtered_alerts" :key="alert.event_id">
          <td>{{ alert.name }}</td>
          <td class="d-none d-md-table-cell" v-if="alert.device_id !== null"><a :href="'http://' + alert.device.ip" target="_blank">{{ alert.device.name }}</a></td>
          <td class="d-none d-md-table-cell" v-else>N/A</td>
          <td class="d-none d-md-table-cell" v-if="alert.device_id !== null">{{ alert.input_number }}</td>
          <td class="d-none d-md-table-cell" v-else>N/A</td>
          <td>
            <span v-if="alert.extension !== 0">{{ alert.extension }}</span>
            <span v-else>N/A</span>
          </td>
          <td class="d-none d-md-table-cell">
            <span class="mx-2" :style="{ visibility: event_visual_count(alert.event_id) > 0 ? 'visible' : 'hidden'}">{{ event_visual_count(alert.event_id) }} <i class="fa-solid fa-image"></i></span>
            <span class="mx-2" :style="{ visibility: event_sound_count(alert.event_id) > 0 ? 'visible' : 'hidden'}">{{ event_sound_count(alert.event_id) }} <i class="fa-solid fa-volume-up"></i></span>
            <span class="mx-2" :style="{ visibility: event_text_count(alert.event_id) > 0 ? 'visible' : 'hidden'}">{{ event_text_count(alert.event_id) }} <i class="fa-solid fa-message"></i></span>
          </td>
          <td>
            <div class="dropdown">
              <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
              </button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <router-link :to="{ name: 'EventSummary', params: { event_id: alert.event_id } }" class="dropdown-item">
                  <i class="fa fa-tasks fa-fw" aria-hidden="true"></i>&nbsp;Summary
                </router-link>
                <router-link :to="{ name: 'EventAdd', params: { event_type_id: 3, template_id: alert.event_id } }" class="dropdown-item">
                  <i class="fa fa-copy fa-fw" aria-hidden="true"></i>&nbsp;Duplicate
                </router-link>
                <a class="dropdown-item" href="#" onclick="return false" @click="deleteEvent(alert.event_id)"><i
                  class="fa fa-trash fa-fw"
                  aria-hidden="true"></i>&nbsp;Delete</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" @click="executeAlert(alert.event_id)"><i
                  class="fa fa-play fa-fw" aria-hidden="true"></i> Execute</a>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { EVENT_TYPE } from '../../assets/js/resource-types'

export default {
  computed: {
    ...mapGetters({
      events: 'allEvents',
      event_summaries: 'allEventSummaries',
      phoenix_settings: 'allPhoenixSettings',
      scoped_site_id: 'scopedSiteId',
      feature_visual_alert_enabled: 'featureVisualAlertEnabled'
    }),
    filtered_alerts: function () {
      return this.events.filter(event =>  event.site_id === this.scoped_site_id && event.event_type_id === EVENT_TYPE.Alert)
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
    this.$store.dispatch('getEvents')
    this.$store.dispatch('getEventSummaries')
    this.$store.dispatch('getPhoenixSettings', 'PHOENIX.FEATURE')
  },
  methods: {
    ...mapActions([
      'deleteEvent',
      'executeAlert'
    ]),
    event_sound_count(event_id) {
      return this.event_summaries[event_id] && this.event_summaries[event_id].sounds
    },
    event_visual_count(event_id) {
      return this.event_summaries[event_id] && this.event_summaries[event_id].visuals
    },
    event_text_count(event_id) {
      return this.event_summaries[event_id] && this.event_summaries[event_id].texts
    }
  }
}
</script>

<style scoped>

</style>
